var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.header)?_c('h4',[_vm._v(" "+_vm._s(_vm.header)+" ")]):_vm._e(),(_vm.datacollection)?_c('div',{staticClass:"vacancy-stat"},[_c('VacancyPolarAreaChart',{attrs:{"chart-data":_vm.datacollection,"height":150}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }